// ─────────────────────────────────────────────────────────────
// BGP Cart Bundle Nudge — v3
// Promotes bundle savings in the cart drawer and cart page.
// Shows only when no RumiAMM BYOB bundle is already in cart.
//
// Detection:
// Checks _rumi_byob_bundle_id line item property automatically
// set by the RumiAMM app on every bundle item.
// ─────────────────────────────────────────────────────────────

// ── Styles ───────────────────────────────────────────────────
function injectNudgeStyles() {
  if (document.getElementById('bundle-nudge-styles')) return;

  const style = document.createElement('style');
  style.id = 'bundle-nudge-styles';
  style.textContent = `
    @keyframes nudge-slideup {
      0% {
        opacity: 0;
        transform: translateY(16px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes nudge-shake {
      0%, 100% {
        transform: translateX(0);
      }
      35% {
        transform: translateX(-2px);
      }
      70% {
        transform: translateX(2px);
      }
    }

    @keyframes nudge-glow {
      0%, 100% {
        box-shadow: 0 3px 12px rgba(80,50,30,.06);
        border-left-color: #8D272D;
      }
      50% {
        box-shadow: 0 4px 18px rgba(141,39,45,.13);
        border-left-color: #a83a40;
      }
    }

    /* Drawer nudge */
    .side-cart-bundle-nudge {
      display: none;
      padding: 14px 16px;
      background: linear-gradient(135deg,#fff8ed 0%,#f8eedf 100%);
      border: 1px solid rgba(141,39,45,.16);
      border-left: 3px solid #8D272D;
      margin: 12px 16px;
      border-radius: 6px;
      font-size: .875rem;
      line-height: 1.5;
      box-shadow: 0 3px 12px rgba(80,50,30,.06);
    }

    .side-cart-bundle-nudge.is-entering {
      animation: nudge-slideup .45s cubic-bezier(.22,1,.36,1) forwards;
    }

    .side-cart-bundle-nudge.is-shaking {
      animation:
        nudge-shake .35s ease forwards,
        nudge-glow .5s ease forwards;
    }

    /* Cart page nudge */
    .bundle-nudge-cart {
      padding: 14px 18px;
      background: linear-gradient(135deg,#fff8ed 0%,#f8eedf 100%);
      border: 1px solid rgba(141,39,45,.16);
      border-left: 3px solid #8D272D;
      margin: 16px 0;
      border-radius: 6px;
      font-size: .875rem;
      line-height: 1.5;
      box-shadow: 0 3px 12px rgba(80,50,30,.06);
    }

    .bundle-nudge-cart.is-entering {
      animation: nudge-slideup .45s cubic-bezier(.22,1,.36,1) forwards;
    }

    .bundle-nudge-cart.is-shaking {
      animation:
        nudge-shake .35s ease forwards,
        nudge-glow .5s ease forwards;
    }

    .side-cart-bundle-nudge a,
    .bundle-nudge-cart a {
      transition: opacity .2s ease;
    }

    .side-cart-bundle-nudge a:hover,
    .bundle-nudge-cart a:hover {
      opacity: .72;
      text-decoration: none !important;
    }

    @media(max-width:480px) {
      .side-cart-bundle-nudge {
        margin: 10px 12px;
        padding: 13px 14px;
      }
    }
  `;

  document.head.appendChild(style);
}

// ── Shake loop ───────────────────────────────────────────────
const shakeIntervals = new WeakMap();

function startShakeLoop(nudge) {
  if (shakeIntervals.has(nudge)) {
    clearInterval(shakeIntervals.get(nudge));
  }

  const interval = setInterval(() => {
    if (!document.contains(nudge) || nudge.style.display === 'none') {
      clearInterval(interval);
      return;
    }

    nudge.classList.remove('is-shaking');
    void nudge.offsetWidth;
    nudge.classList.add('is-shaking');

    setTimeout(() => {
      nudge.classList.remove('is-shaking');
    }, 550);
  }, 6000);

  shakeIntervals.set(nudge, interval);
}

function stopShakeLoop(nudge) {
  if (shakeIntervals.has(nudge)) {
    clearInterval(shakeIntervals.get(nudge));
    shakeIntervals.delete(nudge);
  }
}

// ── Drawer: show / hide ──────────────────────────────────────
function showDrawerNudge(nudge) {
  nudge.style.display = 'block';
  nudge.style.opacity = '0';

  nudge.classList.remove('is-entering', 'is-shaking');
  stopShakeLoop(nudge);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      nudge.style.opacity = '';

      nudge.classList.add('is-entering');

      nudge.addEventListener('animationend', () => {
        nudge.classList.remove('is-entering');
        startShakeLoop(nudge);
      }, { once: true });
    });
  });
}

function hideDrawerNudge(nudge) {
  nudge.style.display = 'none';
  stopShakeLoop(nudge);
}

// ── Drawer: inject HTML (once only) ─────────────────────────
function injectDrawerNudge(container) {
  if (container.querySelector('.side-cart-bundle-nudge')) return false;

  const nudge = document.createElement('div');

  nudge.className = 'side-cart-bundle-nudge';

  nudge.innerHTML = `
    <span style="display:block; color:#8D272D; font-size:.68rem; font-weight:900; letter-spacing:.1em; text-transform:uppercase; margin-bottom:4px;">
      Make your order go further
    </span>
    <span style="display:block; color:#3f332c; font-weight:800; font-size:.95rem; line-height:1.35; margin-bottom:3px;">
      Buy 2 or more and save up to ₹126
    </span>
    <span style="display:block; color:#66594f; font-size:.8rem; line-height:1.45;">
      Mix your favourite flavours in a bundle and get better value.
      <a href="/collections/burmans-gun-podi#bgp-combos-section"
        onclick="document.querySelector('theme-drawer#cart-drawer .theme-drawer__close-button')?.click();"
        style="color:#8D272D; font-weight:800; text-decoration:none; white-space:nowrap;">
        See bundles →
      </a>

    </span>
  `;

  const summary = container.querySelector('.cart-drawer__summary');

  if (summary) {
    summary.parentNode.insertBefore(nudge, summary);
    return true;
  }

  return false;
}

// ── Cart page: animate only, Liquid controls visibility ──────
function initCartPageNudge() {
  const nudge = document.querySelector('.bundle-nudge-cart');

  if (!nudge) return;

  nudge.classList.add('is-entering');

  nudge.addEventListener('animationend', () => {
    nudge.classList.remove('is-entering');
    startShakeLoop(nudge);
  }, { once: true });
}

// ── Core check: fetch cart and decide ───────────────────────
function checkAndShowBundleNudge() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {

      // Detect any RumiAMM BYOB bundle in cart via line item property.
      // _rumi_byob_bundle_id is stamped automatically by the app
      // on every bundle item — works for all current & future bundles.
      const hasBundle = cart.items.some(item =>
        item.properties && item.properties['_rumi_byob_bundle_id']
      );

      const cartDrawer = document.querySelector('#cart-drawer');

      if (!cartDrawer) return;

      injectDrawerNudge(cartDrawer);

      const nudge = cartDrawer.querySelector('.side-cart-bundle-nudge');

      if (!nudge) return;

      hasBundle
        ? hideDrawerNudge(nudge)
        : showDrawerNudge(nudge);
    })
    .catch(err =>
      console.warn('[BGP Nudge] Cart fetch failed:', err)
    );
}

// ── MutationObserver: re-check on drawer re-renders ─────────
function observeCartDrawer() {
  const cartDrawer = document.querySelector('#cart-drawer');

  if (!cartDrawer) return;

  let debounceTimer;

  const observer = new MutationObserver(() => {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(
      checkAndShowBundleNudge,
      80
    );
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}

// ── Init ─────────────────────────────────────────────────────
injectNudgeStyles();

document.addEventListener('theme-drawer:open', e => {
  if (e.target && e.target.id === 'cart-drawer') {
    checkAndShowBundleNudge();
  }
});

document.addEventListener(
  'shopify:cart:lines-update',
  checkAndShowBundleNudge
);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    observeCartDrawer();
    initCartPageNudge();
  });
} else {
  observeCartDrawer();
  initCartPageNudge();
}
